import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ExperienceSection from './components/ExperienceSection';
import ProjectsSection from './components/ProjectsSection';
import SkillsSection from './components/SkillsSection';
import CertificationsSection from './components/CertificationsSection';
import BlogSection from './components/BlogSection';
import QuickNotesSection from './components/QuickNotesSection';
import AchievementsSection from './components/AchievementsSection';
import ContactSection from './components/ContactSection';
import ScrollToTop from './components/ScrollToTop';
import ParticleBackground from './components/ParticleBackground';
import CustomCursor from './components/CustomCursor';
import ScrollProgress from './components/ScrollProgress';
import { Toaster } from './components/ui/toaster';

function App() {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatDateTime = (date) => {
    const options = {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    };
    return date.toLocaleString('en-US', options);
  };

  return (
    <BrowserRouter>
      <div className="App bg-black min-h-screen relative">
        <ScrollProgress />
        <CustomCursor />
        <ParticleBackground />
        <Navigation />
        <HeroSection />
        <AboutSection />
        <ExperienceSection />
        <ProjectsSection />
        <AchievementsSection />
        <SkillsSection />
        <CertificationsSection />
        <BlogSection />
        <QuickNotesSection />
        <ContactSection />
        <ScrollToTop />
        <Toaster />

        {/* Footer */}
        <footer className="bg-black border-t border-gray-800 py-8">
          <div className="container mx-auto px-6">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-gray-400 text-sm">
                © 2025 K R Pavan Tej. All rights reserved.
              </p>

              {/* Live Date & Time */}
              <div className="flex items-center gap-2 text-cyan-400 text-sm font-mono bg-gray-900/50 px-4 py-2 rounded-lg border border-cyan-400/20">
                <span className="animate-pulse">●</span>
                <span>{formatDateTime(currentTime)}</span>
              </div>

              <button
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="text-cyan-400 hover:text-cyan-300 text-sm font-medium transition-colors"
              >
                Back to top ↑
              </button>
            </div>
          </div>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;
